import * as axios from './Axios'

const PREFIX = 'user'

export const _update_user_status = (id, data) => axios.put(`${PREFIX}/${id}/update/status`, data)



